import { render, staticRenderFns } from "./AddEditKrok.vue?vue&type=template&id=529e3275"
import script from "./AddEditKrok.vue?vue&type=script&lang=js"
export * from "./AddEditKrok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports